import React, { useState } from 'react';

import clsx from 'clsx';

import useInterval from '../../hooks/useInterval/useInterval';

import { useStyles } from './styles';

import LinearProgress from '@material-ui/core/LinearProgress';

const LoadingScreen = () => {
    const classes = useStyles();
    const [barValue, setBarValue] = useState(0);
    useInterval(
        () => {
            // Your custom logic here
            setBarValue(barValue + (barValue === 66 ? 34 : 33));
        },
        // Delay in milliseconds or null to stop it
        barValue < 100 ? 300 : null,
    );
    return (
        <div className={classes.loadingScreenContainer}>
            <div>Rendering your form...</div>
            <LinearProgress
                classes={{
                    root: classes.linearRoot,
                    colorPrimary: classes.linearColorPrimary,
                    bar: clsx({
                        [classes.linearBar]: barValue !== 100,
                        [classes.linearBarComplete]: barValue === 100,
                    }),
                }}
                variant="determinate"
                value={barValue}
            />
        </div>
    );
};

export default LoadingScreen;
